import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/platform-browser';

const STORE_ID_KEY = 'storeId';
const FEATURE_TAGS_KEY = "featureTags";

const STORE_ID_STATE_KEY = makeStateKey<any>(STORE_ID_KEY);
const FEATURE_TAGS_STATE_KEY = makeStateKey<any>(FEATURE_TAGS_KEY);

@Injectable({
    providedIn: 'root'
})
export class DataTransferService {
    private isBrowser;

    constructor(
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    /**
     * Get the storeId from TransferState.
     * If not available, try to get it from sessionStorage (only in the browser).
     */
    getStoreId() {
        return this.transferState.get(STORE_ID_STATE_KEY, null) || sessionStorage.getItem(STORE_ID_KEY);
    }

    /**
     * Save the storeId in TransferState (used for server-side rendering).
     * Also save it in sessionStorage if running in the browser.
     */
    setStoreId(storeId) {
        if (this.isBrowser) {
            sessionStorage.setItem("storeId", storeId);
        }
        return this.transferState.set(STORE_ID_STATE_KEY, storeId);
    }

    /**
     * Get featureTags from TransferState (used during server-side rendering).
     * If running in the browser, Get featureTags from TransferState and save them to sessionStorage.
     * Session storage session state will be used in components
     */
    getFeatureTags() {
        const stateFeatureTags = this.transferState.get(FEATURE_TAGS_STATE_KEY, null);
        if (stateFeatureTags && this.isBrowser) {
            sessionStorage.setItem(FEATURE_TAGS_KEY, stateFeatureTags);
        }
        return stateFeatureTags;
    }

    /**
     * Save featureTags in TransferState and sessionStorage (CSR and SSR).
     */
    setFeatureTags(featureTags) {
        sessionStorage.setItem(FEATURE_TAGS_KEY, featureTags);
        return this.transferState.set(FEATURE_TAGS_STATE_KEY, featureTags);
    }
}
